export enum GlobalSearchTypeEnum {
  Opportunities = 'opportunities',
  Campaigns = 'campaigns',
  Accounts = 'accounts',
  Channels = 'channels',
}
